const Hourglass = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12L7.3359 8.8906C6.5013 8.3342 6 7.39751 6 6.39445V3H18V6.39445C18 7.39751 17.4987 8.3342 16.6641 8.8906L12 12ZM12 12L16.6641 15.1094C17.4987 15.6658 18 16.6025 18 17.6056V21H6V17.6056C6 16.6025 6.5013 15.6658 7.3359 15.1094L12 12ZM20 21H4M20 3H4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Hourglass;
